import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import {
  MACHINE_COMPONENT_SETUP,
  ADD_MACHINE_COMPONENT,
} from "../apiEndpoints";
import AddMachineComponentForm from "../forms/AddMachineComponentForm";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";

const AddMachineComponentPage = ({ setAddMachineCompPerm }) => {
  const navigate = useNavigate();
  const { data, isLoaded, error, getData } = useGetData();
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  useEffect(() => {
    getData(MACHINE_COMPONENT_SETUP);
  }, []);

  const sendData = async (formValues, reset) => {
    // API calling
    executePost(formValues, ADD_MACHINE_COMPONENT, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Machine Component" }}>
      {isLoaded && !error ? (
        <AddMachineComponentForm
          machineSetup={data}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
          navigate={navigate}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddMachineComponentPage;
